// Copyright (c) 2025 Audere, All Rights Reserved

import { type FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { type SerializedError } from "@reduxjs/toolkit";
import type { ApiErrorResponse } from "../types/projects";
import { HttpStatus } from "../types/auth";
import i18n from "../../i18n";

const t = i18n.getFixedT(null, "errors");
const fallbackMessage = t("fallback");

function isFetchBaseQueryError(
  error: FetchBaseQueryError | SerializedError
): error is FetchBaseQueryError {
  return error && typeof error === "object" && "status" in error;
}

export const getErrorText = (error?: FetchBaseQueryError | SerializedError): string => {
  if (!error) return "";

  if (isFetchBaseQueryError(error)) {
    const { status, data } = error;
    const message = (data as ApiErrorResponse)?.message;
    if (status === HttpStatus.BAD_REQUEST || status === HttpStatus.INTERNAL_SERVER_ERROR) {
      return message || fallbackMessage;
    }
    throw { status };
  }

  return fallbackMessage;
};
